<template>
    <section class="rubrique-hp main-menu" data-index="0">
        <div class="bloc-left">
            <div class="bloc-wrapper">
                <transition name="fade">
                    <div
                            class="img-back"
                            v-for="(img,index) in imgs" :style="'background-image: url('+img+')'"
                            v-if="indexBackground === index"
                            :key="index"
                    ></div>
                </transition>
                <div class="container">
                    <slot name="logo"></slot>
                    <ul class="menu-hp">
                        <li v-for="(item, index) in items" @mouseenter="hoverItem(index)"
                            @mouseleave="leaveItem()" :class="{active : item.index === activeIndex}">
                            <a :href="item.url">{{item.title}}</a>
                            <div class="number">{{index+1 | formatNumber}}</div>
                            <div class="fond-select"></div>
                        </li>
                        <div class="bar-menu-left"></div>
                    </ul>
                    <slot name="links"></slot>
                    <div class="bloc-text" :class="{hidden: menuHovered}">
                        <div class="bloc-titre">
                            <slot name="accroche"></slot>
                        </div>
                    </div>
                    <div class="bar-menu-right"></div>
                    <a class="little-fleche"><span class="icon-arrow-right"></span></a>
                </div>
            </div>
        </div>
        <div class="bloc-right">
            <div class="bloc-wrapper">
                <transition name="fade">
                    <div
                            class="img-back"
                            v-for="(img,index) in imgs" :style="'background-image: url('+img+')'"
                            v-if="indexBackground === index"
                            :key="index"
                    ></div>
                </transition>
                <div class="container">
                    <slot name="logo"></slot>
                    <ul class="menu-hp" v-if="breakpointDownLg">
                        <li v-for="(item, index) in items" @mouseenter="hoverItem(index)"
                            @mouseleave="[indexBackground = 0, menuHovered = false]">
                            <a :href="item.url">{{item.title}}</a>
                            <div class="number">{{index+1 | formatNumber}}</div>
                            <div class="fond-select"></div>
                        </li>
                        <div class="bar-menu-left"></div>
                    </ul>
                    <div class="bloc-text" :class="{hidden: menuHovered}">
                        <div class="bloc-titre">
                            <slot name="accroche"></slot>
                        </div>
                    </div>
                    <div class="bar-menu-right"></div>
                    <a class="little-fleche"><span class="icon-arrow-right"></span></a>
                </div>
            </div>
        </div>
        <img v-for="(img,index) in imgs" :src="img" alt="" class="off">
    </section>
</template>

<script>
    import $ from "jquery";
    import Menu from '../libs/menu'
    import {debounce} from 'lodash'

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
            imgs: {
                type: Array,
                required: true,
            }
        },
        data() {
            return {
                indexBackground: 0,
                menuHovered: false,
                activeIndex: null
            };
        },
        computed: {
            breakpointDownLg() {
                return this.$root.breakpointDownLg;
            },
            breakpointUpXl() {
                return this.$root.breakpointUpXl;
            },
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            hoverItem(index) {
                if (this.breakpointDownMd) {
                    return
                }
                this.indexBackground = index + 1
                this.menuHovered = true
                this.activeIndex = index
            },
            leaveItem() {
                if (this.breakpointDownMd) {
                    return
                }
                this.reInitBackground();
                this.menuHovered = false
                this.activeIndex = null
            },
            reInitBackground: debounce(function(){
                if (!this.menuHovered){
                    this.indexBackground = 0;
                }
            }, 200),
            initLinkMenu() {
                $(".menu-hp a").on("click", function (event) {
                    Menu.handleHashLinks(event)
                })
            }
        },
        mounted() {
            this.initLinkMenu()
        },
        beforeDestroy() {
            $(".menu-hp a").off()
        }
    };
</script>
